// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleSquareOutlinedSvg from "@fishx/icons-svg/es/asn/DribbbleSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareOutlinedSvg
  }));
};

DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
export default React.forwardRef(DribbbleSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DribbbleSquareOutlined.js
// module id = 2475
// module chunks = 0